import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $(".modal.show").modal("hide");
    $(".dropdown-toggle").dropdown("hide");
    $(this.element).modal()
    document.addEventListener("turbo:before-cache", this.beforeCache);
  }

  disconnect() {
    $(this.element).modal("hide");
    document.addEventListener("turbo:before-cache", this.beforeCache);
  }

  beforeCache = () => {
    $(this.element).modal('dispose');
    this.element.remove(); // completely remove the modal
  }
}
